/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';


export interface PraticaEsercenteEligibilitaDTO { 
    can_submit?: boolean;
    reason?: string;
    domanda_esistente_id?: string;
    domanda_esistente_stato?: RichiestaPraticaEsercenteStatus;
}



